export default __webpack_public_path__ + "static/media/rewrite.ed0fe419.svg";